import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller.ts"
import type { IRentalIntakeMaterialization } from "@/interfaces/api/rental-intake-materialization.interface.ts"
import { RentalIntakeMaterialization } from "@/models/rental-intake-materialization.model.ts"
import { RentalIntakeMaterializationRepository } from "@/repositories/rental-intake-materialization-repository.ts"
import { useRentalIntakeMaterializationStore } from "@/store/rental-intake-materializations.store.ts"
import { storeToRefs } from "pinia"
import ModelManager from "@/services/model-manager.ts"
import { ODataQueryBuilder } from "@/builder/odata-query-builder.ts"

export default class RentalIntakeMaterializationController extends GenericModelController<
  RentalIntakeMaterialization,
  IRentalIntakeMaterialization,
  RentalIntakeMaterializationRepository
> {
  rentalIntakeMaterializationStore = useRentalIntakeMaterializationStore()

  constructor() {
    const rentalIntakeMaterializationStore = useRentalIntakeMaterializationStore()
    const { rentalIntakeMaterializations } = storeToRefs(rentalIntakeMaterializationStore)

    const storeFunctionsConfig = { collection: rentalIntakeMaterializations }

    super(
      RentalIntakeMaterialization,
      storeFunctionsConfig,
      new RentalIntakeMaterializationRepository()
    )
  }

  public async getOutstandingRentalIntakeMaterializations(
    query: ODataQueryBuilder = new ODataQueryBuilder()
  ) {
    query.eq("is_outstanding", true)

    return this.getList({ query })
  }

  public async getRentalIntakeMaterializationsById(rimIds: string[]) {
    const missingIds = []
    for (const id of rimIds) {
      if (!ModelManager.getInstance().exists(id)) {
        missingIds.push(id)
      }
    }

    if (missingIds.length === 0) {
      return []
    }

    const query = new ODataQueryBuilder().in("id", missingIds)
    return this.getList({ query })
  }
}
